import { render, staticRenderFns } from "./FacialIngest.vue?vue&type=template&id=550184ba&scoped=true"
import script from "./FacialIngest.vue?vue&type=script&lang=js"
export * from "./FacialIngest.vue?vue&type=script&lang=js"
import style0 from "./FacialIngest.vue?vue&type=style&index=0&id=550184ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550184ba",
  null
  
)

export default component.exports